// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services --------------------

import { cadastrarInteressadoAnuncio } from "../../../services/cadastrarInteressadoAnuncioService";

export const useInteressadoAnuncio = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const resetError = () => setError(null);

  const cadastrar = async (data: any) => {
    setIsLoading(true);
    setError(null);

    try {
      
      const cadastrar = await cadastrarInteressadoAnuncio(data);

      if (cadastrar) {
        setSuccess(true);
        return cadastrar;
      }
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    cadastrar,
    isLoading,
    error,
    success,
    resetError,
  };
};
